var _Circle, _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";
var SvgAdsBannerBasicIcon = function SvgAdsBannerBasicIcon(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "currentColor"
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "m28.282 29.779-1.296-4.901 3.943-3.268-5.07-.281-1.86-4.733-1.859 4.733-5.127.28 4 3.269-1.296 4.9L24 27.019l4.283 2.76Zm5.351-5.746c0 .638.235 1.202.705 1.69s1.023.732 1.662.732v4.788c0 .638-.235 1.202-.704 1.69-.47.488-1.024.732-1.663.732H14.366c-.638 0-1.192-.244-1.662-.732S12 31.88 12 31.243v-4.788c.676 0 1.24-.235 1.69-.705.45-.47.676-1.042.677-1.718 0-.639-.235-1.202-.705-1.69S12.64 21.61 12 21.61v-4.788c0-.639.235-1.202.704-1.69.47-.488 1.024-.732 1.662-.732h19.267c.64 0 1.193.244 1.663.732s.704 1.051.704 1.69v4.788c-.639 0-1.193.244-1.662.732-.47.488-.705 1.051-.705 1.69Z",
    fill: "white"
  })));
};
export default SvgAdsBannerBasicIcon;